<p id="copyright-text">{{ 'footer.text' | translate: { year: year } }}</p>
